'use es6';

import ReportPaginator from '../../reports/inferLogic/components/ReportPaginator';
import { getPageCount } from '../../reports/utils/paginate';
import { jsx as _jsx } from "react/jsx-runtime";
const SnowflakePaginator = ({
  reportOptions,
  dataset,
  onPageChange,
  onLimitChange,
  isMobile
}) => {
  const {
    limit,
    offset
  } = reportOptions;
  const size = dataset && dataset.paginationSize;
  if (limit === undefined || size === undefined) {
    return null;
  }
  const page = Math.floor(offset / limit) + 1;
  const pageCount = getPageCount(size, limit);
  const showPerPageSelector = size > 10;
  const handlePerPageChange = ({
    target: {
      value
    }
  }) => {
    const newLimit = Number(value);
    onPageChange(1);
    onLimitChange(newLimit);
  };
  return /*#__PURE__*/_jsx(ReportPaginator, {
    page: page,
    pageCount: pageCount,
    itemsPerPage: limit,
    onPageChange: onPageChange,
    isMobile: isMobile,
    onPerPageChange: showPerPageSelector ? handlePerPageChange : null
  });
};
export default SnowflakePaginator;